import { FormControl, MenuItem, Stack } from "@mui/material";
import { Control } from "react-hook-form";
import { TreatmentRecordFormState } from "../../../../utils/types/ui/treatmentRecordForm";
import FormAutoComplete from "../../../shareComponents/form/FormAutoComplete";
import FormInput from "../../../shareComponents/form/FormInput";
import BaseInput from "../../../shareComponents/input/BaseInput";
import { useQuery } from "@tanstack/react-query";
import { REACT_QUERY_KEYS } from "../../../../utils/constants/reactQueryKeys";
import { getAllDBConstants } from "../../../../services/dbConstants";
import { useTranslation } from "react-i18next";

interface AssessmentFormProps {
  control: Control<TreatmentRecordFormState>;
}

const defaultSelectItems = [
  {
    id: -1,
    displayText: "-",
  },
];

const AssessmentForm = (props: AssessmentFormProps) => {
  const { control } = props;

  const { t } = useTranslation();

  const { data: dbConstants } = useQuery(
    [REACT_QUERY_KEYS.DB_CONSTANTS],
    getAllDBConstants
  );

  const octMachineTypes = defaultSelectItems.concat(
    dbConstants?.data?.octMachineTypes ?? []
  );

  const snellenTypes = defaultSelectItems.concat(
    dbConstants?.data?.snellenTypes ?? []
  );

  return (
    <Stack>
      <FormControl sx={{ width: 0.5 }}>
        <FormInput
          select
          control={control}
          name={"octMachineId"}
          label={t("singlePharse.OctMachine")}
        >
          {octMachineTypes.map((e) => (
            <MenuItem key={e.id} value={e.id}>
              {e.displayText}
            </MenuItem>
          ))}
        </FormInput>

        <FormInput
          control={control}
          name="cst"
          type="number"
          inputProps={{
            min: 130,
            max: 1200,
          }}
          label="CST"
          placeholder="130 to 1200"
        />
      </FormControl>

      <Stack direction="row" sx={{ marginTop: 2 }}>
        <FormAutoComplete
          sx={{ width: 0.5 }}
          control={control}
          name="vaSnellen"
          label="VA"
          options={snellenTypes}
          getOptionLabel={(option) =>
            option.description == null
              ? option.displayText.toString()
              : option.displayText + "  (" + option.description + ")"
          }
          renderInput={(params) => <BaseInput {...params} label="VA" />}
          isOptionEqualToValue={(option, value) => {
            return true;
          }}
        />
      </Stack>
    </Stack>
  );
};

export default AssessmentForm;
